import axios from 'axios'

const store = {
  namespaced: true,

  state: {
    normal: [],
    priority: [],
    counters: [],
  },
  getters: {
    normal: state => state.normal,
    counters: state => state.counters,
    priority: state => state.priority,
  },
  mutations: {
    SET_STATE (state, { key, value }) {
      state[key] = value
    },
  },
  actions: {
    async getStatus ({ commit }) {
      const response = await axios.get(window.route('current-status'))

      commit('SET_STATE', { key: 'counters', value: response.data.data })
    },
    async getList ({ commit }, type) {
      const response = await axios.get(window.route('queue-list'), {
        params: {
          type,
        },
      })

      commit('SET_STATE', { key: type, value: response.data.data })
    },
  },
}

export default store
